<template>
  <div class="flowType2">
    <b-form-group
      :class="{'error-input' : $v.flow.name.$error}">
      <label>Flow Name*</label>
      <j-input
        v-model="flow.name"
        :max-length="25"
        placeholder="Flow Name"/>
    </b-form-group>

    <b-form-group
      :class="{'error-input' : $v.flow.division.$error}">
      <label>Division*</label>
      <j-single-select
        v-model="flow.division"
        :options="all_division_list"
        :default-data="mode === 'create' ? null : default_division"
        placeholder="Ex: Finance"
        value-format="object"
        label="name"
        @getData="getDataDivision" />
    </b-form-group>
  </div>
</template>

<script>
import { jMixValidationFormFlowType2 } from '@/mixins/validations/flow/jMixValidationFormFlowType2';
import { jMixOptionsFormFlowType2 } from '@/mixins/list-options/flow/jMixOptionsFormFlowType2';
import { jMixModeCreateFlowType2 } from '@/mixins/mode-form/flow/jMixModeCreateFlowType2';
import { jMixModeEditFlowType2 } from '@/mixins/mode-form/flow/jMixModeEditFlowType2';

export default {
  name: 'JFormFlowType2',
  mixins: [
    jMixValidationFormFlowType2,
    jMixOptionsFormFlowType2,
    jMixModeCreateFlowType2,
    jMixModeEditFlowType2,
  ],
  props: {
    mode: {
      type: String,
      default: 'create',
    },
  },
  data() {
    return {
      flow: {
        name: '',
        division: null,
        data_division: null,
      },
    };
  },
  methods: {
    validateForm() {
      this.$v.flow.$touch();
      if (!this.$v.flow.$error) {
        this.$emit('getData', this.flow);
      } else {
        this.$emit('getData', null);
      }
    },

    getDataDivision(val) {
      this.flow.data_division = val;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/form/flow/jFormFlowType2.vue